import PropTypes from "prop-types";

export const M_PropTypes_Shared = {
	className: PropTypes.string,
	style: PropTypes.object,
	children: PropTypes.any,
};
